import { Navigator } from '../../../effects/navigator';
import { CallActions } from '../../../store/call/actions';
import { CallSelectors } from '../../../store/call/selectors';
import { AppThunk } from '../../../store/types';
import { UrlUtil } from '../../../../common/utils/url-util';
import { ICallParams } from '../types';
import { getState } from '../../../store';
import { ConferenceRest } from '../../../../common/rest/conference/conferenceRest';
import { AuthUserEffects } from '../../../effects/authUserEffects';

export class CallAppEffects {

	public static onOpen(
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			const roomId = CallSelectors.getRoomId(getState());
			if (roomId) {
				const params: ICallParams = UrlUtil.getRouteCall();
				if (!params?.roomId) {
					Navigator.openCall(roomId);
				}
				if (!CallSelectors.getIsActive(getState())) {
					dispatch(CallActions.update({
						isActive: true,
					}));
				}
			}
		}
	}

	public static onEnd(
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			dispatch(CallActions.update({
				roomId: '',
				token: '',
			}));
		}
	}

	// The call is over for this client: straight to the home page, with a note in place of the form.
	public static onCallEnded(
		nothingRecorded: boolean,
	): AppThunk {
		return async (
			dispatch,
		) => {
			dispatch(CallActions.update({
				isActive: false,
				roomId: '',
				token: '',
				notice: nothingRecorded ? 'endedNothing' : 'ended',
				startedAt: undefined,
			}));
		}
	}

	public static onLeave(
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			dispatch(CallActions.update({
				isActive: false,
				roomId: '',
				token: '',
				startedAt: undefined,
			}));
		}
	}

	private static SET_USER_SERVICE_ID_RETRY_DELAYS_MS = [1000, 3000, 10000];

	// Retried on network errors / 5xx: besides recording the session it reopens a call the owner
	// re-entered after finishing, and a lost request would leave it finished. Idempotent server-side.
	public static async onParticipantJoin(
		userId: string,
	) {
		const roomId = CallSelectors.getRoomId(getState());
		if (!roomId) return;
		for (let attempt = 0; ; attempt++) {
			try {
				await ConferenceRest.setUserServiceId(roomId, userId);
				return;
			} catch (e) {
				const status = (e as any)?.response?.status;
				const retryable = !status || status >= 500;
				const delay = CallAppEffects.SET_USER_SERVICE_ID_RETRY_DELAYS_MS[attempt];
				if (!retryable || delay === undefined) {
					console.error('setUserServiceId failed', e);
					return;
				}
				await new Promise(resolve => setTimeout(resolve, delay));
			}
		}
	}

	// public static async setConfig(
	// 	config: Partial<ICallState>
	// ) {
	// 	const dispatch = getDispatch();
		// if (CallSelectors.getLang(getState()) !== config.lang) {
	// 		dispatch(CallActions.update(config));
	// 	}
	// }

	public static async setLang(
		lang: string
	) {
		return AuthUserEffects.setLang(lang);
	}

}
